export default __webpack_public_path__ + "static/media/bg-dota-2.c55cb4d3.png";